import SoftwareApplicationLD from './SoftwareApplicationLD'

export default SoftwareApplicationLD
